export default "__VITE_ASSET__pc5YWfdb__"